<template>
  <div ref="container">
    <div class="financial-overview">
      <div class="panel sort-disable">
        <div
          class="panel-heading tw-h-min md:tw-h-[50px] tw-flex tw-flex-col md:tw-flex-row tw-justify-between"
        >
          <span class="panel-title">Saúde da clínica</span>
          <span class="panel-controls tw-mb-4 md:tw-mb-0">
            <date-range-picker
              :dates="dates"
              @dates-submitted="onDatesSubmitted"
            ></date-range-picker>
          </span>
        </div>
        <div class="panel-body tw-w-full">
          <div class="row" v-if="isFetched && hasError">
            <div class="col-md-10 col-md-offset-1">
              <div class=" tw-rounded-md tw-p-4 tw-mb-4 tw-bg-red-100">
                <div class="tw-flex">
                  <div class="tw-ml-3 tw-flex tw-items-center tw-justify-between tw-w-full">
                    <div class="tw-flex-1 md:tw-flex md:tw-justify-between tw-flex-col">
                      <p class="tw-text-sm tw-text-red-700">
                        Não foi possível carregar os dados. Por favor, recarregue a página.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row clinic-health">
            <div class="row">
              <div class="col-md-10 col-md-offset-1">
                <h5 class="mt5 ph10 pb5 br-b fw600">
                  Distribuição do faturamento
                </h5>
                <div class="payment-by-professional">
                  <div v-if="!isFetched" class="tw-text-center tw-mt-4">
                    <img :src="loadingImage" class="tw-inline"/>
                  </div>
                  <table class="table mbn paymments">
                    <tbody>
                      <tr
                        v-for="receivedByProfessional in receivedByProfessionals"
                      >
                        <td class="va-m fw600 text-muted description-pay">
                          <span class="clinic user">
                            <img
                              src="/assets/icons/user-c65d065c9109a9f561ca231afcccbf8db517f44a3ae6b816b4dacf7f4dd77f27.svg"
                              class="tw-inline"
                            />
                            {{ receivedByProfessional.fullName }}
                          </span>
                        </td>
                        <td class="text-right percentage-pa tw-relative">
                          <BlurContent
                            :show-blur="!hasFinancialFeature || !isFetched"
                            :show-title="false"
                          />{{ receivedByProfessional.percentage }}%
                        </td>
                        <td class="fs13 text-right fw600 tw-relative">
                          <BlurContent
                            :show-blur="!hasFinancialFeature || !isFetched"
                            :show-title="false"
                          />
                          {{ receivedByProfessional.amountTotal }}
                        </td>
                        <td class="payment-by-professional-last-colum">
                          <a
                            data-modal="true"
                            :href="
                              hasFinancialFeature
                                ? `/financial/payments-for-professional?professional_id=${
                                    receivedByProfessional.id
                                  }&start-date=${dates.start.unix()}&end-date=${dates.end.unix()}`
                                : '/establishment/plans/upgrade?feature=financial'
                            "
                            >Ver</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row mt50">
              <div class="col-md-10 col-md-offset-1">
                <h5 class="mt5 ph10 pb5 br-b fw600">Formas de pagamento</h5>
                <div v-if="!isFetched" class="tw-text-center tw-mt-4">
                  <img :src="loadingImage" class="tw-inline"/>
                </div>
                <table class="table mbn paymments pl-24">
                  <tbody>
                    <tr v-for="paymentMethod in paymentMethods">
                      <td class="va-m fw600 text-muted description-pay">
                        {{ paymentMethod.paymentMethod }}
                      </td>
                      <td class="va-m percentage-pay tw-relative">
                        <BlurContent
                          :show-blur="!hasFinancialFeature || !isFetched"
                          :show-title="false"
                        />
                        {{ paymentMethod.percentage }}%
                      </td>
                      <td class="fs13 text-right fw600 tw-relative">
                        <BlurContent
                          :show-blur="!hasFinancialFeature || !isFetched"
                          :show-title="false"
                        />
                        {{ paymentMethod.amountTotal }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row mt50">
              <div class="col-md-10 col-md-offset-1">
                <h5 class="mt5 ph10 pb5 br-b fw600">
                  Tratamentos mais realizados no período
                </h5>
                <div class="common-treatments">
                  <div v-if="!isFetched" class="tw-text-center tw-mt-4">
                    <img :src="loadingImage" class="tw-inline"/>
                  </div>
                  <table class="table mbn paymments pl-24">
                    <tbody>
                      <tr v-if="treatments.length == 0">
                        <td colspan="3">
                          <small v-if="isFetched">Carregando tratamentos</small>
                          <small v-else>Nenhum tratamento foi realizado</small>
                        </td>
                      </tr>
                      <tr v-for="(treatment, i) in treatments" :key="treatment.name">
                        <td class="va-m fw600 text-muted fw600 description-pay">
                          {{ i + 1 }} - {{ treatment.name }}
                        </td>
                        <td
                          class="fs13 text-center fw600 percentage-pay tw-relative"
                        >
                          <BlurContent
                            :show-blur="!hasFinancialFeature || !isFetched"
                            :show-title="false"
                          />
                          {{ treatment.count }}
                        </td>
                        <td class="fs13 text-right fw600 tw-relative">
                          <BlurContent
                            :show-blur="!hasFinancialFeature || !isFetched"
                            :show-title="false"
                          />
                          {{ treatment.amountTotal }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <a v-if="has_more_treatments" data-modal="true" :href="hasMoreTreatmentsUrl" class="tw-ml-6 tw-text-sm tw-text-gray-600">Ver todos tratamentos</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import BlurContent from "../blur-content.vue";
import loadingImage from 'images/spinner.svg';
import { isInViewport } from "../../helpers/isInViewport"

export default {
  props: {
    hasFinancialFeature: Boolean,
  },
  components: {
    BlurContent,
  },
  data() {
    return {
      receivedByProfessionals: [],
      treatments: [],
      paymentMethods: [],
      dates: {
        start: moment().startOf("month"),
        end: moment().endOf("month"),
      },
      isFetched: false,
      hasError: false,
      has_more_treatments: false,
      loadingImage,
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      this.handleScroll()
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    fetch() {
      axios
        .get(
          `/financial/health?start=${this.dates.start.unix()}&end=${this.dates.end.unix()}`
        )
        .then((response) => {
          this.receivedByProfessionals = response.data.receivedByProfessionals;
          this.paymentMethods = response.data.paymentMethods;
          this.treatments = response.data.treatments;
          this.has_more_treatments = response.data.has_more_treatments;
          this.error = false;
        }).catch(() => {
          this.hasError = true;
        }).finally(() => {
          this.isFetched = true;
        });
    },
    onDatesSubmitted() {
      this.fetch();
    },
    handleScroll() {
      if (this.isFetched) {
        return;
      }
      if (isInViewport(this.$refs.container, true)) {
        this.fetch();
        window.removeEventListener("scroll", this.handleScroll);
      }
    },
  },
  computed: {
    hasMoreTreatmentsUrl(){
      return `/financial/treatments?start=${encodeURIComponent(this.dates.start.unix())}&end=${encodeURIComponent(this.dates.end.unix())}`
    }
  }
};
</script>
